// extracted by mini-css-extract-plugin
export default {"awardCard":"Awardcard_awardCard__hn94p","awardCard__yearsList":"Awardcard_awardCard__yearsList__4EGhj","awardCard__image":"Awardcard_awardCard__image__23V47"};